// extracted by mini-css-extract-plugin
export default {"GitHubAvatar_0":"ValueIcon-module__GitHubAvatar_0__T2pQj2m","Box_0":"ValueIcon-module__Box_0__VXkBeAh"};